import { Slower } from "./Slower.js";
export async function loadExternalSlowInteraction(engine, refresh = true) {
    await engine.addInteractor("externalSlow", (container) => new Slower(container), refresh);
}
export * from "./Options/Classes/Slow.js";
export * from "./Options/Interfaces/ISlow.js";
